import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import ScrollToTop from '@/components/ScrollToTop';
import ComingSoonPage from '@/pages/ComingSoonPage';
import MarketplacePage from '@/pages/MarketplacePage';
import DroneDetailPage from '@/pages/DroneDetailPage';
import SellPage from '@/pages/SellPage';
import AboutPage from '@/pages/AboutPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsOfServicePage from '@/pages/TermsOfServicePage';
import CookiePolicyPage from '@/pages/CookiePolicyPage';
import CountryPage from '@/pages/CountryPage';
import BuyerDashboard from '@/pages/account/BuyerDashboard';
import SellerDashboard from '@/pages/account/SellerDashboard';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<ComingSoonPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/drone/:droneId" element={<DroneDetailPage />} />
            <Route path="/sell" element={<SellPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            <Route path="/country/:countrySlug" element={<CountryPage />} />
            <Route path="/account/buyer" element={<BuyerDashboard />} />
            <Route path="/account/seller" element={<SellerDashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;